import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MesangemService } from '../../services/mensagem.service';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import { FeiraClienteService } from '../../services/feira-cliente.service';
import { FeiraClienteDto } from '../../dto/feira-cliente.dto';

@Component({
  selector: 'app-modal-adicionar-mensagem',
  templateUrl: './modal-adicionar-mensagem.component.html',
  styleUrl: './modal-adicionar-mensagem.component.scss'
})
export class ModalAdicionarMensagemComponent implements OnInit {
  @Input() clienteId!: string;

  mensagemForm!: FormGroup;
  currentLength: number = 0;
  loading: boolean = false;
  loadingFeiras: boolean = false;
  listaFeiras: FeiraClienteDto[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private mensagemService: MesangemService,
    private toastService: ToastService,
    private feiraClienteService: FeiraClienteService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.mensagemForm = this.fb.group({
      feiraClienteId: ['', [Validators.required]],
      mensagem: ['', [Validators.required, Validators.maxLength(510)]],
      mensagemRelevante: [false]
    });

    // Inicializar contador
    this.currentLength = 0;

    // Carregar feiras do cliente
    this.carregarFeiras();
  }

  carregarFeiras(): void {
    if (!this.clienteId) {
      return;
    }

    this.loadingFeiras = true;
    this.feiraClienteService.getFeirasCliente(this.clienteId).subscribe({
      next: (feiras) => {
        this.listaFeiras = feiras || [];
        this.loadingFeiras = false;
      },
      error: (error) => {
        console.error('Erro ao carregar feiras:', error);
        this.toastService.show('Erro ao carregar feiras', {
          classname: 'bg-danger text-light',
        });
        this.loadingFeiras = false;
      }
    });
  }

  onInput(): void {
    const mensagemValue = this.mensagemForm.get('mensagem')?.value || '';
    this.currentLength = mensagemValue.length;
  }

  adicionarMensagem(): void {
    if (this.mensagemForm.invalid) {
      this.mensagemForm.markAllAsTouched();
      return;
    }

    this.loading = true;

    const payload = {
      clienteId: this.clienteId,
      feiraClienteId: this.mensagemForm.value.feiraClienteId,
      mensagem: this.mensagemForm.value.mensagem,
      mensagemRelevante: this.mensagemForm.value.mensagemRelevante || false
    };

    this.mensagemService.adicionarMensagem(payload).subscribe({
      next: () => {
        this.toastService.show("Mensagem adicionada com sucesso!", {
          classname: "bg-success text-light",
        });
        this.activeModal.close(true);
      },
      error: (error) => {
        this.toastService.show("Erro ao adicionar mensagem!", {
          classname: "bg-danger text-light",
        });
        console.error(error);
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    });
  }
}

